import { all } from 'redux-saga/effects';
import decryptCrmDataWatcher from './DecryptCrmData/decryptCrmData';
import getAppointments from './GetAppointments/getAppointments';
import getAutoCompleteOptions from './GetAutoCompleteOptions/getAutoCompleteOptions';
import getExternalSelectOptions from './GetExternalSelectOptions/getExternalSelectOptions';
import isDomainInternalWatcher from './IsDomainInternal/isDomainInternal';
import getLegalStatementWatcher from './LegalStatement/getLegalStatement';
import subscribeToNewsletterWatcher from './Newsletter/subscribeToNewsletter';
import getSubmissionStatusWatcher from './SubmissionStatus/getSubmissionStatus';
import validatePhone from './ValidatePhone/validatePhone';
import validatePostCode from './ValidatePostcode/validatePostcode';
import getCustomerMatchesWatcher from './getCustomerMatches/getCustomerMatches';
import prepareSupplierMatchingWatcher from './prepareSupplierMatching/prepareSupplierMatching';
import getDynamicNewsletterWatcher from './GetDynamicNewsletter/getDynamicNewsletter';
import handleAnswerQuestionSideEffectsWatcher from './handleAnswerQuestionSideEffects/handleAnswerQuestionSideEffects';
import getSupplierCardLogosWatcher from './getSupplierCardLogos/getSupplierCardLogos';
import submitSelectAndConnectWatcher from './SelectAndConnect/submitSelectAndConnect';
import getPlacePredictionsWatcher from './getPlacePredictions/getPlacePredictions';
import handleGoogleAddressSelectedWatcher from './handleGoogleAddressSelected/handleGoogleAddressSelected';
import handleZipCodeProvidedWatcher from './handleZipCodeProvided/handleZipCodeProvided';
import populateFormFieldWatcher from './populateFormField/populateFormField';

function* rootSaga() {
  yield all([
    getAppointments(),
    getDynamicNewsletterWatcher(),
    getLegalStatementWatcher(),
    getSubmissionStatusWatcher(),
    getSupplierCardLogosWatcher(),
    getCustomerMatchesWatcher(),
    getPlacePredictionsWatcher(),
    prepareSupplierMatchingWatcher(),
    validatePhone(),
    validatePostCode(),
    getAutoCompleteOptions(),
    getExternalSelectOptions(),
    decryptCrmDataWatcher(),
    subscribeToNewsletterWatcher(),
    isDomainInternalWatcher(),
    handleAnswerQuestionSideEffectsWatcher(),
    submitSelectAndConnectWatcher(),
    handleGoogleAddressSelectedWatcher(),
    handleZipCodeProvidedWatcher(),
    populateFormFieldWatcher(),
  ]);
}

export default rootSaga;
